import { Description } from "./description.model";
import { ActionTypes } from "./description.actions";
import { Action } from "@ngrx/store";

export interface State {
  searchQuery: string;
  descriptions: Description[];
  selectedDescription: Description | null;
  searching: boolean;
  loading: boolean;
  showDetails: boolean;
  type: string;
}

export const initialState: State = {
  searchQuery: null,
  descriptions: [],
  selectedDescription: null,
  searching: false,
  loading: false,
  showDetails: false,
  type: "diagnosis",
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case ActionTypes.LIST:
      return Object.assign({}, state, {
        searching: true,
        type: action.payload,
      });

    case ActionTypes.FILTER:
      return Object.assign({}, state, { searchQuery: action.payload });

    case ActionTypes.LIST_COMPLETE:
      return Object.assign({}, state, {
        descriptions: action.payload,
        searching: false,
      });

    case ActionTypes.LIST_FAIL:
      return Object.assign({}, state, { searching: false });

    case ActionTypes.LOAD:
      return Object.assign({}, state, { loading: true, showDetails: true });

    case ActionTypes.LOAD_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        selectedDescription: action.payload,
      });

    case ActionTypes.SAVE:
      return Object.assign({}, state, { loading: true });

    case ActionTypes.SAVE_SUCCESS:
      return Object.assign({}, state, { showDetails: false, loading: false });

    case ActionTypes.SAVE_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.RESET:
      return Object.assign({}, state, { loading: true });

    case ActionTypes.RESET_SUCCESS:
      return Object.assign({}, state, { showDetails: false, loading: false });

    case ActionTypes.RESET_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.CLOSE:
      return Object.assign({}, state, {
        showDetails: false,
        selectedDescription: null,
      });

    default:
      return state;
  }
}

export const getDescriptions = (state: State) =>
  state.descriptions
    .filter((description) => {
      if (!state.searchQuery) {
        return true;
      } else {
        const q = state.searchQuery.toLowerCase();
        return description.name.toLowerCase().indexOf(q) > -1;
      }
    })
    .sort((a, b) => {
      return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    });
export const getSelected = (state: State) => state.selectedDescription;
export const isSearching = (state: State) => state.searching;
export const isLoading = (state: State) => state.loading;
export const getSearchQuery = (state: State) => state.searchQuery;
export const getShowDetails = (state: State) => state.showDetails;
export const getType = (state: State) => state.type;



// WEBPACK FOOTER //
// /app/src/app/core/store/description/description.reducer.ts